import { useState } from 'react';
import { Shield, Github, Twitter, Linkedin, Mail, X, FileText, Database, Lock, User, Download, 
  ScrollText, Key, CheckCircle, XCircle, Cookie, Info, Layers, Settings, Globe,Star, Check, Edit, 
  Camera, UploadCloud,Image,
   Zap, ShieldCheck, Tag, ChevronDown, MessageSquare, Paperclip, Upload, AlertCircle, Send,
   AlertTriangle } from 'lucide-react';

const Footer = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [analyticsConsent, setAnalyticsConsent] = useState(false);
  const [marketingConsent, setMarketingConsent] = useState(false);
  const [rating, setRating] = useState(0); 
  const [feedbackType, setFeedbackType] = useState(''); 
  const [screenshot, setScreenshot] = useState(null); 

  
  const closeModal = () => setActiveModal(null);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  
  const openModal = (modalName) => {
    setActiveModal(modalName);
  };
  
  // Current year
  const currentYear = new Date().getFullYear();
  
  return (
    <>
      {/* Footer */}
      <footer className="mt-12 bg-gradient-to-b from-gray-900 to-black text-gray-300">
        
        
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand Section */}
            <div className="flex flex-col">
                <div className="flex items-center space-x-2">
                <div className="p-1.5 rounded-lg bg-gradient-to-br from-blue-600 to-blue-800 shadow-lg">
                    <Shield className="w-5 h-5 text-white" />
                </div>
                <span className="text-lg font-semibold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
                    HashVault Pro
                </span>
                </div>
       
              <p className="text-sm text-gray-400 mb-6">
                Advanced cryptographic hashing solution for secure data verification and integrity management.
              </p>
              <div className="flex space-x-4 mt-auto">
                <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors">
                  <Github className="w-5 h-5 text-gray-300" />
                </a>
                <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors">
                  <Twitter className="w-5 h-5 text-gray-300" />
                </a>
                <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors">
                  <Linkedin className="w-5 h-5 text-gray-300" />
                </a>
              </div>
            </div>

            {/* Product Links */}
            <div className="flex flex-col">
              <h3 className="text-lg font-semibold text-white mb-4">Product</h3>
              <ul className="flex flex-col space-y-3">
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Features</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">API</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Integration</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Pricing</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Updates</a></li>
              </ul>
            </div>

            {/* Resources Links */}
            <div className="flex flex-col">
              <h3 className="text-lg font-semibold text-white mb-4">Resources</h3>
              <ul className="flex flex-col space-y-3">
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Documentation</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Tutorials</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Blog</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Community</a></li>
                <li><a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">Security</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="flex flex-col">
              <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
              <ul className="flex flex-col space-y-3">
                <li className="flex items-center">
                  <Mail className="w-4 h-4 mr-2 text-blue-400" />
                  <span className="text-gray-400">support@hashvault.pro</span>
                </li>
                <li>
                  <button 
                    onClick={() => openModal('contact')} 
                    className="text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    Contact Support
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => openModal('feedback')} 
                    className="text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    Submit Feedback
                  </button>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Divider */}
          <div className="border-t border-gray-800 my-8"></div>
          
          {/* Bottom Bar */}
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-500 mb-4 md:mb-0">
              &copy; {currentYear} HashVault Pro. Developed by F/N Nuru The_geek
            </div>
            <div className="flex flex-wrap justify-center space-x-6 text-sm text-gray-500">
              <button 
                onClick={() => openModal('privacy')} 
                className="hover:text-gray-300 transition-colors"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => openModal('terms')} 
                className="hover:text-gray-300 transition-colors"
              >
                Terms of Service
              </button>
              <button 
                onClick={() => openModal('cookies')} 
                className="hover:text-gray-300 transition-colors"
              >
                Cookie Policy
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal Popups */}
      {activeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-900 rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="border-b border-gray-800 px-6 py-4 flex justify-between items-center sticky top-0 bg-gray-900">
              <h3 className="text-xl font-bold text-white">
                {activeModal === 'privacy' && 'Privacy Policy'}
                {activeModal === 'terms' && 'Terms of Service'}
                {activeModal === 'cookies' && 'Cookie Policy'}
                {activeModal === 'contact' && 'Contact Support'}
                {activeModal === 'feedback' && 'Submit Feedback'}
              </h3>
              <button 
                onClick={closeModal}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            {/* Modal Content */}
            <div className="p-6">
            {activeModal === 'privacy' && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-lg p-4 animate-fade-in">
                <div className="relative w-full max-w-4xl bg-gray-900 rounded-xl border border-gray-700/50 shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
                  {/* Gradient header */}
                  <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 border-b border-gray-800 p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-2xl font-bold text-white flex items-center">
                          <Shield className="w-6 h-6 mr-3 text-blue-400" />
                          Privacy & Data Protection
                        </h3>
                        <p className="text-blue-300 mt-1">Last updated: {new Date().toLocaleDateString()}</p>
                      </div>
                      <button
                        onClick={() => setActiveModal(null)}
                        className="p-2 rounded-full hover:bg-gray-800/50 transition-colors"
                      >
                        <X className="w-5 h-5 text-gray-400" />
                      </button>
                    </div>
                  </div>

                  {/* Scrollable content */}
                  <div className="overflow-y-auto p-6 space-y-8 custom-scrollbar">
                    {/* Introduction */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-blue-900/30 border border-blue-800/50 mt-0.5">
                          <FileText className="w-4 h-4 text-blue-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Introduction</h4>
                          <p className="text-gray-300 leading-relaxed">
                            At <span className="text-blue-400">HashVault Pro</span>, we prioritize your data security and privacy. 
                            This comprehensive policy outlines our stringent measures to protect your information 
                            while using our cryptographic services.
                          </p>
                        </div>
                      </div>
                    </section>

                    {/* Data Collection */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-purple-900/30 border border-purple-800/50 mt-0.5">
                          <Database className="w-4 h-4 text-purple-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Data Collection</h4>
                          <div className="space-y-3">
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <h5 className="font-medium text-blue-300 mb-1">Input Data</h5>
                              <p className="text-gray-300 text-sm">
                                Your hashed inputs are processed ephemerally in memory and never persisted to disk or transmitted externally.
                              </p>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <h5 className="font-medium text-blue-300 mb-1">Analytics</h5>
                              <p className="text-gray-300 text-sm">
                                We collect anonymized usage metrics to improve performance, excluding all sensitive cryptographic operations.
                              </p>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <h5 className="font-medium text-blue-300 mb-1">Zero-Knowledge Architecture</h5>
                              <p className="text-gray-300 text-sm">
                                Cryptographic operations occur client-side with military-grade encryption before any network transmission.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Security Measures */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-green-900/30 border border-green-800/50 mt-0.5">
                          <Lock className="w-4 h-4 text-green-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Security Measures</h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <div className="flex items-center mb-2">
                                <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                                <h5 className="font-medium text-white">Memory Isolation</h5>
                              </div>
                              <p className="text-gray-300 text-sm">
                                Sensitive data is processed in isolated memory segments with automatic zeroization.
                              </p>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <div className="flex items-center mb-2">
                                <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                                <h5 className="font-medium text-white">FIPS 140-2 Compliance</h5>
                              </div>
                              <p className="text-gray-300 text-sm">
                                Cryptographic modules meet rigorous government security standards.
                              </p>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <div className="flex items-center mb-2">
                                <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                                <h5 className="font-medium text-white">Audit Trails</h5>
                              </div>
                              <p className="text-gray-300 text-sm">
                                All access attempts are logged with blockchain-verified timestamps.
                              </p>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <div className="flex items-center mb-2">
                                <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                                <h5 className="font-medium text-white">Quantum Resistance</h5>
                              </div>
                              <p className="text-gray-300 text-sm">
                                Post-quantum cryptographic algorithms protect against future threats.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Data Rights */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-yellow-900/30 border border-yellow-800/50 mt-0.5">
                          <User className="w-4 h-4 text-yellow-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Your Rights</h4>
                          <div className="space-y-3">
                            <div className="flex items-start space-x-3">
                              <div className="w-2 h-2 rounded-full bg-yellow-500 mt-2 flex-shrink-0"></div>
                              <p className="text-gray-300">
                                <span className="font-medium text-white">Access & Portability:</span> Request all stored data in standardized formats
                              </p>
                            </div>
                            <div className="flex items-start space-x-3">
                              <div className="w-2 h-2 rounded-full bg-yellow-500 mt-2 flex-shrink-0"></div>
                              <p className="text-gray-300">
                                <span className="font-medium text-white">Rectification:</span> Correct inaccurate personal information
                              </p>
                            </div>
                            <div className="flex items-start space-x-3">
                              <div className="w-2 h-2 rounded-full bg-yellow-500 mt-2 flex-shrink-0"></div>
                              <p className="text-gray-300">
                                <span className="font-medium text-white">Erasure:</span> Complete deletion of all associated data
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>

                  {/* Footer */}
                  <div className="p-4 border-t border-gray-800 bg-gray-900/50 flex justify-between items-center">
                    <div className="flex items-center space-x-2">
                      <Shield className="w-4 h-4 text-green-500" />
                      <span className="text-xs text-gray-400">SOC 2 Type II Certified</span>
                    </div>
                    <button className="px-4 py-2 bg-blue-600/90 hover:bg-blue-500 rounded-lg text-sm font-medium transition-colors flex items-center space-x-2">
                      <Download className="w-4 h-4" />
                      <span>Download Full Policy</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
              
              {activeModal === 'terms' && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-lg p-4 animate-fade-in">
                <div className="relative w-full max-w-4xl bg-gray-900 rounded-xl border border-gray-700/50 shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
                  {/* Gradient header */}
                  <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 border-b border-gray-800 p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-2xl font-bold text-white flex items-center">
                          <FileText className="w-6 h-6 mr-3 text-blue-400" />
                          Terms of Service
                        </h3>
                        <p className="text-blue-300 mt-1">Effective: {new Date().toLocaleDateString()} | Version 3.2.1</p>
                      </div>
                      <button
                        onClick={() => setActiveModal(null)}
                        className="p-2 rounded-full hover:bg-gray-800/50 transition-colors"
                      >
                        <X className="w-5 h-5 text-gray-400" />
                      </button>
                    </div>
                  </div>

                  {/* Scrollable content */}
                  <div className="overflow-y-auto p-6 space-y-8 custom-scrollbar">
                    {/* Introduction */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-blue-900/30 border border-blue-800/50 mt-0.5">
                          <ScrollText className="w-4 h-4 text-blue-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Agreement Overview</h4>
                          <p className="text-gray-300 leading-relaxed">
                            These <span className="text-blue-400 font-medium">Terms of Service</span> constitute a legally binding agreement between you and <span className="text-blue-400">HashVault Pro</span> governing your access to and use of our cryptographic services, APIs, and related technologies.
                          </p>
                        </div>
                      </div>
                    </section>

                    {/* Usage Rights */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-purple-900/30 border border-purple-800/50 mt-0.5">
                          <Key className="w-4 h-4 text-purple-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">License Grant</h4>
                          <div className="space-y-4">
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <h5 className="font-medium text-blue-300 mb-2 flex items-center">
                                <CheckCircle className="w-4 h-4 mr-2 text-green-400" />
                                Permitted Uses
                              </h5>
                              <ul className="list-disc list-inside text-gray-300 text-sm space-y-2 pl-4">
                                <li>Commercial and non-commercial cryptographic operations</li>
                                <li>Integration via our documented APIs</li>
                                <li>Security auditing and penetration testing</li>
                                <li>Academic research with proper attribution</li>
                              </ul>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <h5 className="font-medium text-blue-300 mb-2 flex items-center">
                                <XCircle className="w-4 h-4 mr-2 text-red-400" />
                                Restrictions
                              </h5>
                              <ul className="list-disc list-inside text-gray-300 text-sm space-y-2 pl-4">
                                <li>Reverse engineering or decompilation</li>
                                <li>Resale or redistribution of services</li>
                                <li>Illegal or malicious activities</li>
                                <li>Bypassing security controls</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Service Level */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-green-900/30 border border-green-800/50 mt-0.5">
                          <Zap className="w-4 h-4 text-green-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Service Level Agreement</h4>
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <div className="flex items-center mb-2">
                                <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                                <h5 className="font-medium text-white">Uptime Guarantee</h5>
                              </div>
                              <p className="text-gray-300 text-sm">
                                99.95% SLA for enterprise plans with automatic credit compensation
                              </p>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <div className="flex items-center mb-2">
                                <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                                <h5 className="font-medium text-white">Support Response</h5>
                              </div>
                              <p className="text-gray-300 text-sm">
                                Critical issues: 1 hour | General inquiries: 24 hours
                              </p>
                            </div>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <div className="flex items-center mb-2">
                                <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                                <h5 className="font-medium text-white">Security Updates</h5>
                              </div>
                              <p className="text-gray-300 text-sm">
                                Critical patches deployed within 24 hours of disclosure
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Compliance */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-yellow-900/30 border border-yellow-800/50 mt-0.5">
                          <ShieldCheck className="w-4 h-4 text-yellow-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Compliance & Regulations</h4>
                          <div className="space-y-3">
                            <div className="flex items-start space-x-3">
                              <div className="w-2 h-2 rounded-full bg-yellow-500 mt-2 flex-shrink-0"></div>
                              <p className="text-gray-300">
                                <span className="font-medium text-white">GDPR:</span> Full compliance with EU data protection regulations
                              </p>
                            </div>
                            <div className="flex items-start space-x-3">
                              <div className="w-2 h-2 rounded-full bg-yellow-500 mt-2 flex-shrink-0"></div>
                              <p className="text-gray-300">
                                <span className="font-medium text-white">CCPA:</span> California Consumer Privacy Act provisions
                              </p>
                            </div>
                            <div className="flex items-start space-x-3">
                              <div className="w-2 h-2 rounded-full bg-yellow-500 mt-2 flex-shrink-0"></div>
                              <p className="text-gray-300">
                                <span className="font-medium text-white">Export Controls:</span> Compliant with EAR and ITAR regulations
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Termination */}
                    <section className="space-y-4">
                      <div className="flex items-start space-x-3">
                        <div className="p-1.5 rounded-lg bg-red-900/30 border border-red-800/50 mt-0.5">
                          <AlertTriangle className="w-4 h-4 text-red-400" />
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-white mb-2">Termination & Suspension</h4>
                          <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                            <p className="text-gray-300 text-sm mb-3">
                              HashVault Pro reserves the right to suspend or terminate access immediately for:
                            </p>
                            <ul className="list-disc list-inside text-gray-300 text-sm space-y-2 pl-4">
                              <li>Violation of these terms</li>
                              <li>Unlawful activities</li>
                              <li>Security threats</li>
                              <li>Non-payment (for paid plans)</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>

                  {/* Acceptance & Footer */}
                  <div className="p-4 border-t border-gray-800 bg-gray-900/50 flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
                    <div className="flex items-center space-x-3">
                        <input
                          type="checkbox"
                          id="terms-acceptance"
                          className="h-4 w-4 rounded border-gray-600 bg-gray-700 text-blue-500"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="terms-acceptance" className="text-sm text-gray-300">
                          I acknowledge that I have read and agree to these Terms
                        </label>
                      </div>
                    <div className="flex space-x-3">
                      <button className="px-4 py-2 border border-gray-600 hover:bg-gray-800/50 rounded-lg text-sm font-medium transition-colors">
                        View Revision History
                      </button>
                      <button className="px-4 py-2 bg-blue-600/90 hover:bg-blue-500 rounded-lg text-sm font-medium transition-colors flex items-center space-x-2">
                        <Download className="w-4 h-4" />
                        <span>Download Full Terms</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
              
              {activeModal === 'cookies' && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-lg p-4 animate-fade-in">
                  <div className="relative w-full max-w-4xl bg-gray-900 rounded-xl border border-gray-700/50 shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
                    {/* Gradient header with cookie icon */}
                    <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 border-b border-gray-800 p-6">
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="text-2xl font-bold text-white flex items-center">
                            <Cookie className="w-6 h-6 mr-3 text-blue-400" />
                            Cookie & Tracking Policy
                          </h3>
                          <p className="text-blue-300 mt-1">Last updated: {new Date().toLocaleDateString()} | v2.1.3</p>
                        </div>
                        <button
                          onClick={() => setActiveModal(null)}
                          className="p-2 rounded-full hover:bg-gray-800/50 transition-colors"
                        >
                          <X className="w-5 h-5 text-gray-400" />
                        </button>
                      </div>
                    </div>

                    {/* Scrollable content */}
                    <div className="overflow-y-auto p-6 space-y-8 custom-scrollbar">
                      {/* Introduction */}
                      <section className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="p-1.5 rounded-lg bg-blue-900/30 border border-blue-800/50 mt-0.5">
                            <Info className="w-4 h-4 text-blue-400" />
                          </div>
                          <div>
                            <h4 className="text-xl font-semibold text-white mb-2">Policy Overview</h4>
                            <p className="text-gray-300 leading-relaxed">
                              This <span className="text-blue-400 font-medium">Cookie Policy</span> explains how <span className="text-blue-400">HashVault Pro</span> uses cookies and similar tracking technologies to enhance security and user experience while maintaining strict privacy standards.
                            </p>
                          </div>
                        </div>
                      </section>

                      {/* Cookie Types */}
                      <section className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="p-1.5 rounded-lg bg-purple-900/30 border border-purple-800/50 mt-0.5">
                            <Layers className="w-4 h-4 text-purple-400" />
                          </div>
                          <div>
                            <h4 className="text-xl font-semibold text-white mb-2">Cookie Categories</h4>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                              {/* Essential Cookies */}
                              <div className="p-4 bg-gray-800/30 rounded-lg border border-blue-700/30">
                                <div className="flex items-center mb-2">
                                  <div className="w-2 h-2 rounded-full bg-blue-500 mr-2 animate-pulse"></div>
                                  <h5 className="font-medium text-white">Essential</h5>
                                </div>
                                <p className="text-gray-300 text-sm mb-3">
                                  Required for core functionality and security
                                </p>
                                <div className="text-xs text-blue-400">
                                  <span className="font-medium">Examples:</span> CSRF tokens, session IDs
                                </div>
                              </div>
                              
                              {/* Analytics Cookies */}
                              <div className="p-4 bg-gray-800/30 rounded-lg border border-purple-700/30">
                                <div className="flex items-center mb-2">
                                  <div className="w-2 h-2 rounded-full bg-purple-500 mr-2 animate-pulse"></div>
                                  <h5 className="font-medium text-white">Performance</h5>
                                </div>
                                <p className="text-gray-300 text-sm mb-3">
                                  Help improve user experience (opt-in required)
                                </p>
                                <div className="text-xs text-purple-400">
                                  <span className="font-medium">Examples:</span> Google Analytics
                                </div>
                              </div>
                              
                              {/* Marketing Cookies */}
                              <div className="p-4 bg-gray-800/30 rounded-lg border border-red-700/30">
                                <div className="flex items-center mb-2">
                                  <div className="w-2 h-2 rounded-full bg-red-500 mr-2 animate-pulse"></div>
                                  <h5 className="font-medium text-white">Marketing</h5>
                                </div>
                                <p className="text-gray-300 text-sm mb-3">
                                  Used for targeted content (disabled by default)
                                </p>
                                <div className="text-xs text-red-400">
                                  <span className="font-medium">Examples:</span> Facebook Pixel
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      {/* Cookie Management */}
                      <section className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="p-1.5 rounded-lg bg-green-900/30 border border-green-800/50 mt-0.5">
                            <Settings className="w-4 h-4 text-green-400" />
                          </div>
                          <div>
                            <h4 className="text-xl font-semibold text-white mb-2">Control & Preferences</h4>
                            
                            {/* Cookie Consent Manager */}
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50 mb-4">
                              <h5 className="font-medium text-white mb-3">Your Current Preferences</h5>
                              
                              <div className="space-y-3">
                                {/* Essential Cookies (always on) */}
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center">
                                    <div className="w-2 h-2 rounded-full bg-blue-500 mr-3"></div>
                                    <span className="text-gray-300">Essential Cookies</span>
                                  </div>
                                  <div className="relative inline-block w-12 h-6 rounded-full bg-gray-700 opacity-50 cursor-not-allowed">
                                    <input 
                                      type="checkbox" 
                                      className="opacity-0 w-0 h-0" 
                                      checked 
                                      disabled
                                    />
                                    <span className="absolute top-0 left-0 right-0 bottom-0 rounded-full bg-blue-600"></span>
                                    <span className="absolute left-6 top-1 bg-white w-4 h-4 rounded-full transition-transform"></span>
                                  </div>
                                </div>
                                
                                {/* Analytics Cookies */}
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center">
                                    <div className="w-2 h-2 rounded-full bg-purple-500 mr-3"></div>
                                    <span className="text-gray-300">Performance Cookies</span>
                                  </div>
                                  <label className="relative inline-flex items-center cursor-pointer">
                                    <input 
                                      type="checkbox" 
                                      className="sr-only peer" 
                                      checked={analyticsConsent}
                                      onChange={() => setAnalyticsConsent(!analyticsConsent)}
                                    />
                                    <div className="w-12 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                                  </label>
                                </div>
                                
                                {/* Marketing Cookies */}
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center">
                                    <div className="w-2 h-2 rounded-full bg-red-500 mr-3"></div>
                                    <span className="text-gray-300">Marketing Cookies</span>
                                  </div>
                                  <label className="relative inline-flex items-center cursor-pointer">
                                    <input 
                                      type="checkbox" 
                                      className="sr-only peer" 
                                      checked={marketingConsent}
                                      onChange={() => setMarketingConsent(!marketingConsent)}
                                    />
                                    <div className="w-12 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600"></div>
                                  </label>
                                </div>
                              </div>
                            </div>
                            
                            <p className="text-gray-300 text-sm">
                              Changes will take effect immediately and persist across sessions. Essential cookies cannot be disabled as they are required for security and core functionality.
                            </p>
                          </div>
                        </div>
                      </section>

                      {/* Data Protection */}
                      <section className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="p-1.5 rounded-lg bg-yellow-900/30 border border-yellow-800/50 mt-0.5">
                            <Shield className="w-4 h-4 text-yellow-400" />
                          </div>
                          <div>
                            <h4 className="text-xl font-semibold text-white mb-2">Data Protection Measures</h4>
                            <div className="p-4 bg-gray-800/30 rounded-lg border border-gray-700/50">
                              <ul className="list-disc list-inside text-gray-300 text-sm space-y-2 pl-4">
                                <li>All cookies use <span className="text-blue-400">Secure</span> and <span className="text-blue-400">HttpOnly</span> flags</li>
                                <li>Strict <span className="text-blue-400">SameSite</span> policies enforced</li>
                                <li>Automatic expiration (max 7 days for non-essential)</li>
                                <li>No personally identifiable information stored</li>
                                <li>Regular security audits of all tracking implementations</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>

                    {/* Footer with actions */}
                    <div className="p-4 border-t border-gray-800 bg-gray-900/50 flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
                      <div className="flex items-center space-x-2">
                        <Globe className="w-4 h-4 text-blue-400" />
                        <span className="text-xs text-gray-400">GDPR, CCPA, and ePrivacy Directive compliant</span>
                      </div>
                      <div className="flex space-x-3">
                        <button 
                          className="px-4 py-2 border border-gray-600 hover:bg-gray-800/50 rounded-lg text-sm font-medium transition-colors"
                          onClick={() => {
                            setAnalyticsConsent(false);
                            setMarketingConsent(false);
                          }}
                        >
                          Reject All Non-Essential
                        </button>
                        <button 
                          className="px-4 py-2 bg-blue-600/90 hover:bg-blue-500 rounded-lg text-sm font-medium transition-colors"
                          onClick={() => {
                            // Handle save preferences
                            setActiveModal(null);
                          }}
                        >
                          Save Preferences
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              {activeModal === 'contact' && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-lg p-4 animate-fade-in overflow-y-auto">
                  <div className="relative w-full max-w-2xl bg-gray-900 rounded-xl border border-gray-700/50 shadow-2xl flex flex-col max-h-[90vh]">
                    {/* Sticky header */}
                    <div className="sticky top-0 z-10 bg-gradient-to-r from-blue-900/30 to-purple-900/30 border-b border-gray-800 p-6">
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="text-2xl font-bold text-white flex items-center">
                            <Mail className="w-6 h-6 mr-3 text-blue-400" />
                            Contact Security Support
                          </h3>
                          <p className="text-blue-300 mt-1">24/7 encrypted communication</p>
                        </div>
                        <button
                          onClick={() => setActiveModal(null)}
                          className="p-2 rounded-full hover:bg-gray-800/50 transition-colors"
                        >
                          <X className="w-5 h-5 text-gray-400" />
                        </button>
                      </div>
                    </div>

                    {/* Scrollable content */}
                    <div className="overflow-y-auto flex-1">
                      <div className="p-6">
                        {/* Status indicators */}
                        <div className="flex flex-wrap gap-4 mb-6">
                          <div className="flex items-center">
                            <div className="w-2.5 h-2.5 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                            <span className="text-xs text-green-400">Secure connection</span>
                          </div>
                          <div className="flex items-center">
                            <Lock className="w-4 h-4 text-blue-400 mr-2" />
                            <span className="text-xs text-blue-400">End-to-end encrypted</span>
                          </div>
                        </div>

                        <form className="space-y-6">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Name field */}
                            <div className="relative">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <User className="w-4 h-4 mr-2" />
                                Full Name
                              </label>
                              <input
                                type="text"
                                className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent placeholder-gray-500 transition-all duration-200"
                                placeholder="John Doe"
                                required
                              />
                            </div>

                            {/* Email field */}
                            <div className="relative">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <Mail className="w-4 h-4 mr-2" />
                                Email Address
                              </label>
                              <input
                                type="email"
                                className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent placeholder-gray-500 transition-all duration-200"
                                placeholder="john@example.com"
                                required
                              />
                            </div>

                            {/* Subject dropdown */}
                            <div className="relative md:col-span-2">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <Tag className="w-4 h-4 mr-2" />
                                Inquiry Type
                              </label>
                              <div className="relative">
                                <select className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent appearance-none transition-all duration-200 pr-10">
                                  <option value="">Select a category</option>
                                  <option value="security">Security Concern</option>
                                  <option value="billing">Billing Question</option>
                                  <option value="technical">Technical Support</option>
                                  <option value="enterprise">Enterprise Inquiry</option>
                                  <option value="other">Other</option>
                                </select>
                                <ChevronDown className="w-5 h-5 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none" />
                              </div>
                            </div>

                            {/* Message field */}
                            <div className="relative md:col-span-2">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <MessageSquare className="w-4 h-4 mr-2" />
                                Message
                              </label>
                              <textarea
                                rows="5"
                                className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent placeholder-gray-500 transition-all duration-200"
                                placeholder="Describe your issue in detail..."
                                required
                              ></textarea>
                            </div>

                            {/* Attachments */}
                            <div className="relative md:col-span-2">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <Paperclip className="w-4 h-4 mr-2" />
                                Attachments (Optional)
                              </label>
                              <div className="border-2 border-dashed border-gray-700/50 rounded-lg p-6 text-center hover:border-blue-500/30 transition-colors duration-200 relative">
                                <Upload className="w-10 h-10 mx-auto text-gray-500 mb-3" />
                                <p className="text-sm text-gray-400 mb-1">Drag & drop files here or click to browse</p>
                                <p className="text-xs text-gray-500">Max 10MB per file (Logs, screenshots, etc.)</p>
                                <input
                                  type="file"
                                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                  multiple
                                />
                              </div>
                            </div>

                            {/* Priority selector */}
                            <div className="relative md:col-span-2">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <AlertCircle className="w-4 h-4 mr-2" />
                                Priority Level
                              </label>
                              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                <label className="flex items-center space-x-2 p-3 rounded-lg border border-gray-700 hover:bg-gray-800/30 cursor-pointer">
                                  <input type="radio" name="priority" className="form-radio text-blue-500" value="low" />
                                  <span className="text-gray-300">Low</span>
                                </label>
                                <label className="flex items-center space-x-2 p-3 rounded-lg border border-gray-700 hover:bg-gray-800/30 cursor-pointer">
                                  <input type="radio" name="priority" className="form-radio text-yellow-500" value="medium" defaultChecked />
                                  <span className="text-gray-300">Medium</span>
                                </label>
                                <label className="flex items-center space-x-2 p-3 rounded-lg border border-gray-700 hover:bg-gray-800/30 cursor-pointer">
                                  <input type="radio" name="priority" className="form-radio text-red-500" value="high" />
                                  <span className="text-gray-300">High</span>
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Sticky submit button */}
                          <div className="sticky bottom-0 bg-gray-900/80 backdrop-blur-sm pt-4 -mx-6 px-6 pb-6 border-t border-gray-800/50">
                            <button
                              type="submit"
                              className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center group"
                            >
                              <Send className="w-5 h-5 mr-2 transition-transform group-hover:translate-x-1" />
                              <span>Send Secure Message</span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="p-4 border-t border-gray-800/50 bg-gray-900/30 text-center">
                      <p className="text-xs text-gray-500 flex items-center justify-center space-x-2">
                        <Lock className="w-3 h-3" />
                        <span>All communications are encrypted with AES-256</span>
                      </p>
                    </div>
                  </div>
                </div>
              )}
              
              {activeModal === 'feedback' && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-lg p-4 animate-fade-in overflow-y-auto">
                    <div className="relative w-full max-w-2xl max-h-[90vh] bg-gray-900 rounded-xl border border-gray-700/50 shadow-2xl flex flex-col">
                      {/* Gradient header - sticky */}
                      <div className="sticky top-0 z-10 bg-gradient-to-r from-blue-900/30 to-purple-900/30 border-b border-gray-800 p-6">
                        <div className="flex justify-between items-start">
                          <div>
                            <h3 className="text-2xl font-bold text-white flex items-center">
                              <MessageSquare className="w-6 h-6 mr-3 text-blue-400" />
                              Product Feedback
                            </h3>
                            <p className="text-blue-300 mt-1">Help us improve HashVault Pro</p>
                          </div>
                          <button
                            onClick={() => setActiveModal(null)}
                            className="p-2 rounded-full hover:bg-gray-800/50 transition-colors"
                          >
                            <X className="w-5 h-5 text-gray-400" />
                          </button>
                        </div>
                      </div>

                      {/* Scrollable content area */}
                      <div className="overflow-y-auto flex-1">
                        <div className="p-6 space-y-6">
                          {/* Feedback rating */}
                          <div className="flex flex-col items-center py-4">
                            <h4 className="text-lg font-medium text-white mb-4">How would you rate your experience?</h4>
                            <div className="flex space-x-2">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                  key={star}
                                  className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-200 ${
                                    rating >= star 
                                      ? 'bg-yellow-500/20 border-2 border-yellow-400 text-yellow-400 transform hover:scale-110' 
                                      : 'bg-gray-800/50 border-2 border-gray-700 text-gray-500 hover:bg-gray-700/50'
                                  }`}
                                  onClick={() => setRating(star)}
                                >
                                  <Star className="w-6 h-6" fill={rating >= star ? "currentColor" : "none"} />
                                </button>
                              ))}
                            </div>
                            <div className="flex justify-between w-full mt-2 px-2">
                              <span className="text-xs text-gray-500">Poor</span>
                              <span className="text-xs text-gray-500">Excellent</span>
                            </div>
                          </div>

                          <form className="space-y-5">
                            {/* Email field */}
                            <div className="relative">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <Mail className="w-4 h-4 mr-2" />
                                Email (Optional)
                                <span className="text-xs text-gray-500 ml-2">For follow-up only</span>
                              </label>
                              <input
                                type="email"
                                className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent placeholder-gray-500 transition-all duration-200"
                                placeholder="your@email.com"
                              />
                            </div>

                            {/* Feedback type */}
                            <div className="relative">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <Tag className="w-4 h-4 mr-2" />
                                Feedback Type
                              </label>
                              <div className="grid grid-cols-2 gap-3">
                                {[
                                  { value: 'feature', label: 'Feature Request', desc: 'Suggest new functionality', color: 'blue' },
                                  { value: 'bug', label: 'Bug Report', desc: 'Report unexpected behavior', color: 'red' },
                                  { value: 'general', label: 'General Feedback', desc: 'Share your experience', color: 'purple' },
                                  { value: 'other', label: 'Other', desc: 'Something else', color: 'green' }
                                ].map((type) => (
                                  <label 
                                    key={type.value}
                                    className={`flex items-center space-x-3 p-3 rounded-lg border cursor-pointer transition-all ${
                                      feedbackType === type.value 
                                        ? `border-${type.color}-500 bg-${type.color}-900/20` 
                                        : 'border-gray-700 hover:bg-gray-800/30'
                                    }`}
                                  >
                                    <input 
                                      type="radio" 
                                      name="feedbackType" 
                                      className="hidden" 
                                      checked={feedbackType === type.value}
                                      onChange={() => setFeedbackType(type.value)}
                                    />
                                    <div className={`w-5 h-5 rounded-full border flex items-center justify-center ${
                                      feedbackType === type.value 
                                        ? `border-${type.color}-500 bg-${type.color}-500` 
                                        : 'border-gray-600'
                                    }`}>
                                      {feedbackType === type.value && <Check className="w-3 h-3 text-white" />}
                                    </div>
                                    <div>
                                      <h4 className="text-sm font-medium text-white">{type.label}</h4>
                                      <p className="text-xs text-gray-400">{type.desc}</p>
                                    </div>
                                  </label>
                                ))}
                              </div>
                            </div>

                            {/* Feedback details */}
                            <div className="relative">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <Edit className="w-4 h-4 mr-2" />
                                Detailed Feedback
                              </label>
                              <textarea
                                rows="5"
                                className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent placeholder-gray-500 transition-all duration-200"
                                placeholder={`Describe your ${feedbackType === 'feature' ? 'feature request' : feedbackType === 'bug' ? 'bug' : 'feedback'} in detail...`}
                                required
                              ></textarea>
                            </div>

                            {/* Screenshot attachment */}
                            <div className="relative">
                              <label className="block text-sm font-medium text-gray-400 mb-2 flex items-center">
                                <Camera className="w-4 h-4 mr-2" />
                                Attach Screenshot (Optional)
                              </label>
                              <div className="border-2 border-dashed border-gray-700/50 rounded-lg p-4 text-center hover:border-blue-500/30 transition-colors duration-200 relative">
                                <div className="flex flex-col items-center">
                                  <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                                  <p className="text-sm text-gray-400 mb-1">Drag & drop files here or click to browse</p>
                                  <p className="text-xs text-gray-500">Supports PNG, JPG (Max 5MB)</p>
                                </div>
                                <input
                                  type="file"
                                  accept="image/png, image/jpeg"
                                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                  onChange={(e) => setScreenshot(e.target.files[0])}
                                />
                              </div>
                              {screenshot && (
                                <div className="mt-3 flex items-center justify-between p-3 bg-gray-800/30 rounded-lg">
                                  <div className="flex items-center space-x-3">
                                    <img className="w-10 h-10 rounded object-cover" src={URL.createObjectURL(screenshot)} alt="Screenshot preview" />
                                    <span className="text-sm text-gray-300">{screenshot.name}</span>
                                  </div>
                                  <button 
                                    type="button"
                                    className="p-1 text-gray-400 hover:text-red-400"
                                    onClick={() => setScreenshot(null)}
                                  >
                                    <X className="w-4 h-4" />
                                  </button>
                                </div>
                              )}
                            </div>

                            {/* Submit button - sticky bottom */}
                            <div className="sticky bottom-0 bg-gray-900/80 backdrop-blur-sm pt-4 -mx-6 px-6 pb-6 border-t border-gray-800/50">
                              <button
                                type="submit"
                                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center group"
                              >
                                <Send className="w-5 h-5 mr-2 transition-transform group-hover:translate-x-1" />
                                <span>Submit Feedback</span>
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            
            {/* Modal Footer */}
            <div className="border-t border-gray-800 px-6 py-4 sticky bottom-0 bg-gray-900">
              <button
                onClick={closeModal}
                className="bg-gray-700 hover:bg-gray-600 text-white font-medium py-2 px-4 rounded-lg transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;